import { createFileRoute } from '@tanstack/react-router';

import { ContractPage } from '@/features/commercial/contract-page';

export const Route = createFileRoute('/_app/projects/$projectId/commercial/contract')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <ContractPage projectId={projectId} />;
}
